import { render, staticRenderFns } from "./edit-main.vue?vue&type=template&id=52ca46b2&scoped=true&"
import script from "./edit-main.vue?vue&type=script&lang=js&"
export * from "./edit-main.vue?vue&type=script&lang=js&"
import style0 from "./edit-main.vue?vue&type=style&index=0&id=52ca46b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca46b2",
  null
  
)

export default component.exports